var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EBDFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7422 16.5188L17.6277 15.1907C17.467 15.1187 17.2906 15.0888 17.1152 15.1039C16.9397 15.119 16.771 15.1786 16.625 15.277L14.9582 16.386C13.9424 15.8926 13.1199 15.0748 12.6207 14.0618L13.723 12.3751C13.8208 12.2289 13.8805 12.0606 13.8968 11.8855C13.913 11.7104 13.8853 11.534 13.816 11.3723L12.4812 8.25786C12.3881 8.04756 12.2304 7.8724 12.031 7.75777C11.8316 7.64315 11.6009 7.59502 11.3723 7.62036C10.4755 7.73784 9.65193 8.17696 9.05464 8.85609C8.45735 9.53522 8.12699 10.4081 8.125 11.3126C8.125 16.5852 12.4148 20.8751 17.6875 20.8751C18.5919 20.8731 19.4648 20.5427 20.144 19.9454C20.8231 19.3481 21.2622 18.5245 21.3797 17.6278C21.405 17.3992 21.3569 17.1685 21.2423 16.969C21.1277 16.7696 20.9525 16.6119 20.7422 16.5188Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contacts-icon.32f342dd076ca0371c18114e244fd2e2.svg";
export { ForwardRef as ReactComponent };